import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const AboutUs = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/dlyuiad05y`}
        maxHeight="80%"
      />
    </>
  );
};

export default AboutUs;
